import Button from "@/components/button/Button"
import { useGlobalContext } from "@/components/context/GlobalContext"
import { SvgIcon } from "@/components/icon"
import DividerWithHex from "@/components/modal-dark/components/divider-with-hex/DividerWithHex"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { Col, Row } from "antd"
import { FC, useState } from "react"
import "./LinkSuccessfulNotice.less"

const { Title, Paragraph } = WebsiteTypography

const LinkSuccessfulNotice: FC = () => {
  const { currentLink } = useGlobalContext()
  const [copied, setCopied] = useState(false)

  const handleCopyLink = async () => {
    if (!currentLink) return

    try {
      await navigator.clipboard.writeText(currentLink)
      setCopied(true)

      setTimeout(() => {
        setCopied(false)
      }, 2000)
    } catch (e) {
      console.error("Copy failed", e)
    }
  }

  const handleSendEmail = () => {
    if (!currentLink) return

    const subject = encodeURIComponent("Delivery Confirmation Form Link")
    const body = encodeURIComponent(`The Link to Delivery Confirmation Form:\n\n${currentLink}`)

    window.location.href = `mailto:?subject=${subject}&body=${body}`
  }

  const handleSendWhatsApp = () => {
    if (!currentLink) return

    const text = encodeURIComponent(`The Link to Delivery Confirmation Form: ${currentLink}`)

    window.open(`https://wa.me/?text=${text}`, "_blank")
  }

  return (
    <Row className={"link-successful-notice-wrapper"} justify={"center"} style={{ marginTop: 24 }}>
      <Col span={20} xxl={20} xl={20} lg={20} md={24} sm={24} xs={24}>
        <Row justify={"center"} style={{ paddingBottom: 24 }}>
          <SvgIcon type={"circled-tick"} color={"green"} />
        </Row>

        <Title level={3} centered className={"form-section-title"}>
          <span className={"w300"}>{"Link Created "}</span>
          <span className={"bold"}>{"Successfully"}</span>
        </Title>

        <Paragraph centered style={{ paddingTop: 24 }} color={"white"}>
          {"You can now copy and share this link with the person responsible for delivering the application."}
        </Paragraph>

        <DividerWithHex marginBottom={32} marginTop={32} />

        <Row justify={"center"}>
          <Col span={8}>
            <Button
              btnType={"primary"}
              onClick={handleCopyLink}
              text={copied ? "Copied!" : "Copy Link"}
              size={"large"}
              icon={<SvgIcon type={"copy-file"} />}
              block
            />
          </Col>
        </Row>

        <Paragraph centered style={{ paddingTop: 24, paddingBottom: 24 }} color={"white"}>
          {"Or share it via:"}
        </Paragraph>

        <Row justify={"center"}>
          <Col span={16}>
            <Row justify={"center"} gutter={24} className={"social-btns-box"}>
              <Col span={12}>
                <Button
                  size={"large"}
                  btnType={"ghost"}
                  icon={<SvgIcon type={"whatsapp-new"} color={"white"} />}
                  text={"WhatsApp"}
                  textColor={"white"}
                  onClick={handleSendWhatsApp}
                  block
                />
              </Col>
              <Col span={12}>
                <Button
                  size={"large"}
                  btnType={"ghost"}
                  text={"Email"}
                  textColor={"white"}
                  icon={<SvgIcon type={"emails"} color={"white"} />}
                  onClick={handleSendEmail}
                  block
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default LinkSuccessfulNotice
